import { h } from '@stencil/core';
import { DESKTOP_MAX_CONTENT_WIDTH, PRODUCT, PageNames, isIndexDBEnabled, scrollToComponent, getConsumerSpecificData, isPBS, indexDBBreadcrumbs, store, setLinearProductData, ACTION_TYPES, tryParse } from '@pes-ui/utils';
import { observeIntersectionWithHeader, setStickyBarTab, setTabActive, } from '../../globals/stickyBar.utils';
import { storeBreadcrumbs } from '../breadcrumbs/utils';
import { getStickyBarMapping } from '../product-description-page/utils';
import { isBrowser } from '../../globals/utils';
export class ProductsCarousel {
  constructor() {
    this.ref = null;
    this.screenSizeHandler = () => {
      this.arrowsOverlay = !this.mql.matches;
    };
    this.onRecentlyViewedItemClick = async ({ event, id, name, url }) => {
      event.preventDefault();
      const { consumer, storageName } = getConsumerSpecificData(isPBS(), this.hostWithLocale);
      const currentPageStorageKey = `${this.pageType}/${this.pageId}`;
      indexDBBreadcrumbs.setChannel(consumer);
      try {
        const currentBreadcrumbs = await indexDBBreadcrumbs.getValidatedBreadcrumbs({
          storageName,
          key: currentPageStorageKey,
        });
        const breadcrumbsToStore = this.pageType === PRODUCT ? [] : [...currentBreadcrumbs];
        await storeBreadcrumbs({
          url,
          id,
          name,
          breadcrumbs: breadcrumbsToStore,
          storageName,
          pageName: PageNames.PRODUCT,
        });
      }
      catch (e) {
        console.error(`[PES]:${this.pageType} page breadcrumbs can not be fetched from ${storageName} storage`, e);
      }
    };
    this.sectionTitle = undefined;
    this._sectionTitle = undefined;
    this.data = undefined;
    this._data = undefined;
    this.versionLabel = undefined;
    this._versionLabel = undefined;
    this.relationType = undefined;
    this._relationType = undefined;
    this.isBackgroundGrey = false;
    this.pageId = undefined;
    this.pageType = undefined;
    this.hostWithLocale = undefined;
    this.arrowsOverlay = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  setupTabbar() {
    const tabtype = getStickyBarMapping(this.relationType);
    if (!tabtype || !this.sectionTitle)
      return;
    setStickyBarTab(tabtype, [this.sectionTitle]);
    this.observe();
  }
  handleTabClicked(event) {
    if (this.ref && event.detail.title === this.sectionTitle) {
      scrollToComponent(this.ref);
    }
  }
  observe() {
    observeIntersectionWithHeader(this.ref, (entries) => {
      var _a;
      if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
        const tabtype = getStickyBarMapping(this.relationType);
        setTabActive({ type: tabtype, title: this.sectionTitle });
        this.setTabActive.emit();
      }
    });
  }
  componentWillLoad() {
    var _a, _b, _c, _d;
    this.sectionTitle = (_a = tryParse(this._sectionTitle)) !== null && _a !== void 0 ? _a : this.sectionTitle;
    this.data = (_b = tryParse(this._data)) !== null && _b !== void 0 ? _b : this.data;
    this.versionLabel = (_c = tryParse(this._versionLabel)) !== null && _c !== void 0 ? _c : this.versionLabel;
    this.relationType = (_d = tryParse(this._relationType)) !== null && _d !== void 0 ? _d : this.relationType;
    if (!this.relationType)
      return;
    const relationTypeKey = this.relationType;
    store.dispatch(setLinearProductData({ [relationTypeKey]: {
        sectionTitle: this.sectionTitle,
        data: this.data,
        versionLabel: this.versionLabel,
        relationType: this.relationType,
      } }));
    this.unsubscribe = store.subscribe(() => {
      const { data, activeProductTab, lastActionType } = store.getState().product;
      if (lastActionType !== ACTION_TYPES.SET_ACTIVE_PRODUCT_TAB)
        return;
      if (!data[activeProductTab][relationTypeKey])
        return;
      const { sectionTitle, data: carouselData, versionLabel, relationType, } = data[activeProductTab][relationTypeKey];
      this.data = carouselData;
      this.sectionTitle = sectionTitle;
      this.versionLabel = versionLabel;
      this.relationType = relationType;
      if (!(carouselData === null || carouselData === void 0 ? void 0 : carouselData.length))
        return;
      this.setupTabbar();
    });
  }
  componentDidLoad() {
    const screenSize = DESKTOP_MAX_CONTENT_WIDTH + 100;
    this.mql = window.matchMedia(`screen and (min-width: ${screenSize}px)`);
    this.arrowsOverlay = !this.mql.matches;
    if (isBrowser()) {
      this.mql.addListener(this.screenSizeHandler);
    }
    this.setupTabbar();
  }
  disconnectedCallback() {
    var _a;
    this.mql.removeListener(this.screenSizeHandler);
    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    var _a;
    if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.length)) {
      return null;
    }
    const onRecentlyViewedItemClick = isIndexDBEnabled() && this.onRecentlyViewedItemClick;
    return (h("pes-collapsible-container", { class: this.isBackgroundGrey && 'collapsible-container', ref: (el) => (this.ref = el) }, h("h2", { slot: "header", class: Object.assign({ header: true }, (this.relationType && { [`header--${this.relationType}`]: true })) }, this.sectionTitle), h("div", { class: "content" }, h("se-carousel", { "item-min-width": 0, hintWidth: 0, arrowsOverlay: this.arrowsOverlay, pagination: true }, this.data.map((product) => (h("se-carousel-item", { class: "product" }, h("div", { class: {
        product__card: true,
        product__white: this.isBackgroundGrey,
      } }, product.softwareType ? (h("pes-product-card-id-software", Object.assign({}, product, { versionLabel: this.versionLabel, key: product.name, onRecentlyViewedItemClick: onRecentlyViewedItemClick }))) : (h("pes-product-card-id", Object.assign({}, product, { key: product.name, onRecentlyViewedItemClick: onRecentlyViewedItemClick })))))))))));
  }
  static get is() { return "pes-products-carousel"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["products-carousel.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["products-carousel.css"]
    };
  }
  static get properties() {
    return {
      "sectionTitle": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Title of the section"
        },
        "attribute": "section-title",
        "reflect": false
      },
      "_sectionTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-section-title",
        "reflect": false
      },
      "data": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "(IProductCardIdRegular | IProductCardIdSoftware)[]",
          "resolved": "(IProductCardIdRegular | IProductCardIdSoftware)[]",
          "references": {
            "IProductCardIdRegular": {
              "location": "import",
              "path": "./types"
            },
            "IProductCardIdSoftware": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "List of product card objects"
        }
      },
      "_data": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-data",
        "reflect": false
      },
      "versionLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "version-label",
        "reflect": false
      },
      "_versionLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-version-label",
        "reflect": false
      },
      "relationType": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Type of carousel"
        },
        "attribute": "relation-type",
        "reflect": false
      },
      "_relationType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-relation-type",
        "reflect": false
      },
      "isBackgroundGrey": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-background-grey",
        "reflect": false,
        "defaultValue": "false"
      },
      "pageId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "pageId"
        },
        "attribute": "page-id",
        "reflect": false
      },
      "pageType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "pageType: allproducts, category, subcategory, range, product"
        },
        "attribute": "page-type",
        "reflect": false
      },
      "hostWithLocale": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "hostWithLocale contains host, countryCode and languageCode"
        },
        "attribute": "host-with-locale",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "arrowsOverlay": {}
    };
  }
  static get events() {
    return [{
        "method": "setTabActive",
        "name": "setTabActive",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "tabClicked",
        "method": "handleTabClicked",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
